import { roundToNearestHundred } from "@/lib/utils";

export default {
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      item: {
        no_of_months: 0,
        primary_picture: '',
        secondary_picture: ''
      },
      views: {
        add: false
      },
      liked: false,
      quantity: 1,
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.item = this.value;
      this.initCredit();
      this.liked = (JSON.parse(localStorage.getItem('likes')) || []).includes(this.item.id);
    },
    initCredit() {
      this.item.sell_on_credit = 1;
      this.item.no_of_months = 3;
      this.item.credit_price = (0.15 * +this.item.price) + +this.item.price;
      this.item.monthly_amount = roundToNearestHundred(this.item.credit_price / this.item.no_of_months);
    },
    incrementQuantity() {
      if (this.item.quantity === 1) this.showToast('Only one item available', 'orange');
      this.quantity = Math.min((this.item.maximum_order || 10), this.quantity + 1, this.item.quantity || 1)
    },
    decrementQuantity() {
      if (this.item.quantity === 1) this.showToast('Only one item available', 'orange');
      this.quantity = Math.max(1, this.quantity - 1)
    },
    add() {
      this.$bus.$emit('preview', this.item);
    },
    async addLike() {
      if (!this.liked) {
        const res = await this.$http.get(`/item/${ this.item.id }/like`);
        if (res.data.status === true) {
          const likes = JSON.parse(localStorage.getItem('likes')) || []
          likes.push(this.item.id);
          localStorage.setItem('likes', JSON.stringify(likes))
          this.liked = true;
          this.item.likes++
        }
      }
    },
  },
  computed: {
    rating() {
      return Math.round(this.item.ratings / this.item.total_ratings)
    },
    price() {
      return (0.15 * +this.item.price) + +this.item.price;
    },
  },
}
